<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">{{ event.name }}</div>
      <div slot="sub-title">{{moment(event.start_date, 'DD-MM-YYYY') | moment('LL')}}</div>
      <div slot="right">
        <div class="buttons is-right">
          <b-button type="is-primary" icon-left="pencil-outline" @click="payrollModalActive = true">Editar Nómina</b-button>
        </div>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <card-component title="Listado de Binomios" class="has-table has-mobile-sort-spaced" >
        <div slot="headerRight" class="card-header-icon">
          <b-button type="is-link" class="is-pulled-right" @click="downloadBinomios" :loading="isDownloading">
            <b-icon
                icon="file-download"></b-icon>
          </b-button>
        </div>
        <executions-table :eventId ="eventId" slot="content" :key="`executions-table-${executionIdKey}`"/>
      </card-component>
      <card-component title="Gráfica de resultados" class="has-table has-mobile-sort-spaced">
        <executions-scores-chart slot="content" :event-id="eventId" :key="`executions-chart-${executionIdKey}`"/>
      </card-component>
      <payroll-modal :active.sync="payrollModalActive" :event-id="eventId" @close="closeModal"/>
    </section>
  </div>
</template>

<script>
import HeroBar from '@/components/HeroBar'
import CardComponent from '@/components/CardComponent'
import ExecutionsTable from './components/ExecutionsTable'
import ExecutionsScoresChart from './components/ExecutionsScoresChart'
import PayrollModal from './components/PayrollModal'

import EventService from '@/services/EventService'
import ExecutionService from '@/services/ExecutionService'

export default {
  components: {
    HeroBar,
    ExecutionsTable,
    CardComponent,
    ExecutionsScoresChart,
    PayrollModal
  },
  data () {
    return {
      eventId: '',
      event: {
        type: Event
      },
      isDownloading: false,
      payrollModalActive: false,
      executionIdKey: 1
    }
  },
  created () {
    this.eventId = this.$route.params.id
    this.getEvent()
  },
  methods: {
    closeModal () {
      this.executionIdKey++
    },
    getEvent () {
      EventService.getEvent(this.eventId).then(
        response => {
          this.event = response.data.data
        }
      )
    },
    downloadBinomios () {
      this.isDownloading = true
      this.openAlert()
      ExecutionService.downloadBinomios(this.eventId).then(
        (resp) => {
          let blob = new Blob([resp.data], { type: 'application/pdf' })

          var fileURL = window.URL.createObjectURL(blob)
          var fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', `Binomios ESA ${this.event.start_date}.pdf`)
          document.body.appendChild(fileLink)

          fileLink.click()
          this.isDownloading = false
        },
        (err) => {
          console.log(err)
          this.isDownloading = false
        }
      )
    },
    openAlert () {
      this.$buefy.notification.open({
        duration: 4000,
        icon: 'account',
        message: `<icon class="mdi mdi-24px mdi-download"></icon> La descarga comenzará dentro de poco`,
        position: 'is-bottom-left',
        type: 'is-info',
        hasIcon: false
      })
    }
  }
}
</script>
